import axios from '@/plugins/axios'

let http = axios(process.env.VUE_APP_CLIENTES_URL);

class Clientes
{
	obtener_cliente() {
		return http.get(`/portal`);
	}

	listar_creditos() {
		return http.get('/portal/creditos');
	}

	obtener_usuario() {
		return http.get('/portal');
	}

	crear_metodo_contacto(payload) {
		return http.post('/portal/contactos', payload);
	}

	editar_metodo_contacto(id, payload) {
		return http.put(`/portal/contactos/${id}`, payload);
	}

	eliminar_metodo_contacto(id) {
		return http.delete(`/portal/contactos/${id}`);
	}

	crear_direccion(payload) {
		return http.post('/portal/direcciones', payload);
	}

	editar_direccion(id, payload) {
		return http.put(`/portal/direcciones/${id}`, payload);
	}

	eliminar_direccion(id) {
		return http.delete(`/portal/direcciones/${id}`);
	}

	descargar_estado_cuenta(id) {
		// return http.get(`/portal/estado_cuenta/${id}`)
		return http({
			url: `/portal/estado_cuenta/${id}`
			,method: 'GET'
			,responseType: 'blob'
		});
	}

	descargar_estado_cuenta_credito(credito) {
		return http.get(`/portal/estado_cuenta/${credito}/credito`);
	}

	obtener_blog_entradas() {
		return http.get(`/portal/blog`);
	}

	obtener_blog_entrada(id) {
		return http.get(`/portal/blog/${id}`);
	}

	obtener_blog_noleidas() {
		return http.get(`/portal/blog/sin-leer`);
	}

	obtener_acciones() {
		return http.get(`/portal/acciones`);
	}

	ejecutar_accion(id) {
		return http.put(`/portal/acciones/${id}`);
	}

	actualizar_estatus_avatar(payload) {
		return http.post(`/portal/avatar`, payload);
	}
}

export default new Clientes();